import dynamic from 'next/dynamic'
import Head from 'next/head'
import Script from 'next/script'
import { Header, TryEdworking, SubheaderWorkspace } from '../../../js/components'
import { timeDiff } from '../../../js'
import Image from 'next/image'

const Editor = dynamic(() => import('../../../js/Editor'), { ssr: false })
const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })

export async function getServerSideProps(context) {
  context.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59')
  const workspace = context.params.workspace
  const res = await fetch(process.env.NEXT_PUBLIC_VENUSAUR, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      operationName: 'GetWorkspace',
      query:
        'query GetWorkspace($workspace: ID!) {getWorkspace(workspace: $workspace){id title cover emoji description Content project{ id name } createdAt}}',
      variables: { workspace },
    }),
  })
  const data = await res.json()
  if (!data || data.errors) {
    return { notFound: true }
  }
  return { props: { data } }
}

export default function Workspace({ data }) {
  const workspace = data?.data?.getWorkspace
  const title = workspace?.title
  const author = workspace?.project?.name
  const created = timeDiff(workspace?.createdAt)
  const length = Math.ceil(workspace?.description?.split(' ').length / 200)
  const isBlock = !!workspace.Content

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <Head>
        <title>{title?.replace(/\b\w/g, (l) => l.toUpperCase())} | Edworking Share</title>
        <meta name="description" content={title} />
        <meta itemProp="name" content={title} />
        <meta itemProp="image" content={'/images/Blog.png'} />
        <meta itemProp="description" content={title} />
        <meta name="robots" content="noindex, follow"></meta>
        <link rel="shortcut icon" href="/images/favicon.ico" />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <Header type={'workspace'} />
      <SubheaderWorkspace
        type={'workspace'}
        title={title}
        author={author}
        created={created}
        length={length}
      />
      {workspace?.Content?.startsWith('https://') ? (
        <EmbeddedDoc cover={workspace.cover} article={workspace.Content} />
      ) : isBlock ? (
        <ArticleBlock cover={workspace.cover} article={JSON.parse(workspace.Content)} />
      ) : (
        <Article cover={workspace.cover} article={JSON.parse(workspace.description)} />
      )}
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-eu1.hs-scripts.com/25992597.js"
      ></Script>
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}

const Article = ({ article, cover }) => {
  return (
    <section className="article workspace">
      {cover && (
        <Image width={1000} height={300} src={cover} className={`cover`} alt="article cover" />
      )}
      <ReactQuill readOnly={true} theme="bubble" value={article} />
    </section>
  )
}

const ArticleBlock = ({ article, cover }) => {
  return (
    <section className="article workspace">
      {cover && (
        <Image width={1000} height={300} src={cover} className={`cover`} alt="article cover" />
      )}
      <Editor content={article} />
    </section>
  )
}

const EmbeddedDoc = ({ article, cover }) => {
  return (
    <section className="article workspace">
      {cover && (
        <Image width={1000} height={300} src={cover} className={`cover`} alt="article cover" />
      )}
      <div className="embedded">
        <iframe
          src={article}
          sandbox=""
          style={{ visibility: 'visible', border: 'none', width: '1500px', height: '1500px' }}
        />
      </div>
    </section>
  )
}
